//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { exportFile } from '@/api/downloadRequest'
export default {
  name: 'ProductViewList',
  data() {
    return {
      filterForm: {
        bankName: '',
        productName: '',
      },
      pagination: {
        currentPage: 1,
        pageSize: 10,
        total: 0,
      },
      tableData: [],
    }
  },
  created() {
    this.getFinanceProductList()
  },
  methods: {
    /**
     * @description:
     * @Author: quwandong
     * @Date: 2023-10-27 08:47:21
     */
    formatProductType({ productType }) {
      return {
        2: '设备贷',
        3: '生资贷',
        4: '经营贷',
      }[productType]
    },
    //页码切换
    handleCurrentChange(val) {
      this.pagination.currentPage = val
      this.getFinanceProductList()
    },
    // 获取列表数据
    async getFinanceProductList() {
      try {
        let { data } = await this.$http.bank.getFinanceProductList({
          currentPage: this.pagination.currentPage,
          pageSize: this.pagination.pageSize,
          ...this.filterForm,
        })
        this.tableData = data.content
        this.pagination.total = data.recordTotal
      } catch (error) {
        console.log(error)
      }
    },
    // 导出
    handleToExport() {
      this.$http.bank
        .financeProductExport({ ...this.filterForm, isOwner: 0 })
        .then((res) => {
          exportFile(res.data, '金融机构产品查询列表', 'xlsx')
        })
    },
    // 跳详情
    handleToDetail(row) {
      this.$router.push({
        path: '/product/view/detail',
        query: {
          id: row.id,
          businessOutlets: row.businessOutlets,
        },
      })
    },
    // 查询
    handleFilter() {
      this.pagination.currentPage = 1
      this.getFinanceProductList()
    },
    //重置
    handleReset(formName) {
      this.$refs[formName].resetFields()
      setTimeout(() => {
        this.handleFilter()
      }, 500)
    },
    // 银行机构
    bankAssociate(key, cb) {
      if (key !== '') {
        this.loading = true
        this.$http.bank
          .fuzzyQueryList({ key })
          .then(({ data }) => {
            this.loading = false
            let arr = data.map((item, index) => ({ name: item, value: index }))
            cb(arr) // 渲染回调
          })
          .catch((res) => {
            this.loading = false
          })
      }
    },
  },
}
